import {
  AggregateAcademicRiskCountersUseCase,
  ConsolidateAllAcademicRiskDataUseCase,
  CreateAcademicRiskActionUseCase,
  CreateAcademicRiskManagementUseCase,
  DeleteAcademicRiskActionUseCase,
  DeleteAcademicRiskManagementUseCase,
  EndOfActionUseCase,
  FilterAcademicRiskDataUseCase,
  FilterAcademicRiskUIUseCase,
  FilterFutureYearsAcademicRiskUseCase,
  FilterStudentsByCurrentYearAcademicRiskUseCase,
  FilterVigenteStudentsUseCase,
  GetAcademicRiskActionUseCase,
  GetAcademicRiskManagementUseCase,
  GetAcademicRiskStudentUseCase,
  GetActionTypesUseCase,
  GetRiskTypesUseCase,
  ProcessAcademicRiskStudentDataUseCase,
  UpdateAcademicRiskActionUseCase,
  UpdateAcademicRiskManagementUseCase,
} from '@/application/academicRisk';
import {
  academicRiskActionApiRepository,
  academicRiskManagementApiRepository,
  academicRiskStudentApiRepository,
} from '@/infra';

let _aggregateAcademicRiskCountersUseCase: AggregateAcademicRiskCountersUseCase | null =
  null;
let _createAcademicRiskActionUseCase: CreateAcademicRiskActionUseCase | null =
  null;
let _createAcademicRiskManagementUseCase: CreateAcademicRiskManagementUseCase | null =
  null;
let _deleteAcademicRiskActionUseCase: DeleteAcademicRiskActionUseCase | null =
  null;
let _deleteAcademicRiskManagementUseCase: DeleteAcademicRiskManagementUseCase | null =
  null;
let _filterAcademicRiskDataUseCase: FilterAcademicRiskDataUseCase | null = null;
let _filterAcademicRiskUIUseCase: FilterAcademicRiskUIUseCase | null = null;
let _filterVigenteStudentsUseCase: FilterVigenteStudentsUseCase | null = null;
let _filterStudentsByCurrentYearAcademicRiskUseCase: FilterStudentsByCurrentYearAcademicRiskUseCase | null =
  null;
let _getAcademicRiskActionUseCase: GetAcademicRiskActionUseCase | null = null;
let _getAcademicRiskManagementUseCase: GetAcademicRiskManagementUseCase | null =
  null;
let _getAcademicRiskStudentUseCase: GetAcademicRiskStudentUseCase | null = null;
let _getActionTypesUseCase: GetActionTypesUseCase | null = null;
let _getRiskTypesUseCase: GetRiskTypesUseCase | null = null;
let _processAcademicRiskStudentDataUseCase: ProcessAcademicRiskStudentDataUseCase | null =
  null;
let _updateAcademicRiskActionUseCase: UpdateAcademicRiskActionUseCase | null =
  null;
let _updateAcademicRiskManagementUseCase: UpdateAcademicRiskManagementUseCase | null =
  null;
let _filterFutureYearsAcademicRiskUseCase: FilterFutureYearsAcademicRiskUseCase | null =
  null;
let _consolidateAllAcademicRiskDataUseCase: ConsolidateAllAcademicRiskDataUseCase | null =
  null;
let _endOfActionUseCase: EndOfActionUseCase | null = null;

export const aggregateAcademicRiskCountersUseCase =
  (): AggregateAcademicRiskCountersUseCase => {
    if (!_aggregateAcademicRiskCountersUseCase) {
      _aggregateAcademicRiskCountersUseCase =
        new AggregateAcademicRiskCountersUseCase();
    }
    return _aggregateAcademicRiskCountersUseCase;
  };

export const createAcademicRiskActionUseCase =
  (): CreateAcademicRiskActionUseCase => {
    if (!_createAcademicRiskActionUseCase) {
      _createAcademicRiskActionUseCase = new CreateAcademicRiskActionUseCase(
        academicRiskActionApiRepository,
      );
    }
    return _createAcademicRiskActionUseCase;
  };

export const createAcademicRiskManagementUseCase =
  (): CreateAcademicRiskManagementUseCase => {
    if (!_createAcademicRiskManagementUseCase) {
      _createAcademicRiskManagementUseCase =
        new CreateAcademicRiskManagementUseCase(
          academicRiskManagementApiRepository,
        );
    }
    return _createAcademicRiskManagementUseCase;
  };

export const deleteAcademicRiskActionUseCase =
  (): DeleteAcademicRiskActionUseCase => {
    if (!_deleteAcademicRiskActionUseCase) {
      _deleteAcademicRiskActionUseCase = new DeleteAcademicRiskActionUseCase(
        academicRiskActionApiRepository,
      );
    }
    return _deleteAcademicRiskActionUseCase;
  };

export const deleteAcademicRiskManagementUseCase =
  (): DeleteAcademicRiskManagementUseCase => {
    if (!_deleteAcademicRiskManagementUseCase) {
      _deleteAcademicRiskManagementUseCase =
        new DeleteAcademicRiskManagementUseCase(
          academicRiskManagementApiRepository,
        );
    }
    return _deleteAcademicRiskManagementUseCase;
  };

export const filterAcademicRiskDataUseCase =
  (): FilterAcademicRiskDataUseCase => {
    if (!_filterAcademicRiskDataUseCase) {
      _filterAcademicRiskDataUseCase = new FilterAcademicRiskDataUseCase();
    }
    return _filterAcademicRiskDataUseCase;
  };

export const filterAcademicRiskUIUseCase = (): FilterAcademicRiskUIUseCase => {
  if (!_filterAcademicRiskUIUseCase) {
    _filterAcademicRiskUIUseCase = new FilterAcademicRiskUIUseCase();
  }
  return _filterAcademicRiskUIUseCase;
};

export const filterVigenteStudentsUseCase =
  (): FilterVigenteStudentsUseCase => {
    if (!_filterVigenteStudentsUseCase) {
      _filterVigenteStudentsUseCase = new FilterVigenteStudentsUseCase();
    }
    return _filterVigenteStudentsUseCase;
  };

export const filterStudentsByCurrentYearAcademicRiskUseCase =
  (): FilterStudentsByCurrentYearAcademicRiskUseCase => {
    if (!_filterStudentsByCurrentYearAcademicRiskUseCase) {
      _filterStudentsByCurrentYearAcademicRiskUseCase =
        new FilterStudentsByCurrentYearAcademicRiskUseCase();
    }
    return _filterStudentsByCurrentYearAcademicRiskUseCase;
  };

export const getAcademicRiskActionUseCase =
  (): GetAcademicRiskActionUseCase => {
    if (!_getAcademicRiskActionUseCase) {
      _getAcademicRiskActionUseCase = new GetAcademicRiskActionUseCase(
        academicRiskActionApiRepository,
      );
    }

    return _getAcademicRiskActionUseCase;
  };

export const getAcademicRiskManagementUseCase =
  (): GetAcademicRiskManagementUseCase => {
    if (!_getAcademicRiskManagementUseCase) {
      _getAcademicRiskManagementUseCase = new GetAcademicRiskManagementUseCase(
        academicRiskManagementApiRepository,
      );
    }
    return _getAcademicRiskManagementUseCase;
  };

export const getAcademicRiskStudentUseCase =
  (): GetAcademicRiskStudentUseCase => {
    if (!_getAcademicRiskStudentUseCase)
      _getAcademicRiskStudentUseCase = new GetAcademicRiskStudentUseCase(
        academicRiskStudentApiRepository,
        filterVigenteStudentsUseCase(),
        filterStudentsByCurrentYearAcademicRiskUseCase(),
      );

    return _getAcademicRiskStudentUseCase;
  };

export const getActionTypesUseCase = (): GetActionTypesUseCase => {
  if (!_getActionTypesUseCase) {
    _getActionTypesUseCase = new GetActionTypesUseCase(
      academicRiskActionApiRepository,
    );
  }

  return _getActionTypesUseCase;
};

export const getRiskTypesUseCase = (): GetRiskTypesUseCase => {
  if (!_getRiskTypesUseCase) {
    _getRiskTypesUseCase = new GetRiskTypesUseCase(
      academicRiskActionApiRepository,
    );
  }

  return _getRiskTypesUseCase;
};

export const processAcademicRiskStudentDataUseCase =
  (): ProcessAcademicRiskStudentDataUseCase => {
    if (!_processAcademicRiskStudentDataUseCase) {
      _processAcademicRiskStudentDataUseCase =
        new ProcessAcademicRiskStudentDataUseCase();
    }
    return _processAcademicRiskStudentDataUseCase;
  };

export const updateAcademicRiskActionUseCase =
  (): UpdateAcademicRiskActionUseCase => {
    if (!_updateAcademicRiskActionUseCase) {
      _updateAcademicRiskActionUseCase = new UpdateAcademicRiskActionUseCase(
        academicRiskActionApiRepository,
      );
    }
    return _updateAcademicRiskActionUseCase;
  };

export const updateAcademicRiskManagementUseCase =
  (): UpdateAcademicRiskManagementUseCase => {
    if (!_updateAcademicRiskManagementUseCase) {
      _updateAcademicRiskManagementUseCase =
        new UpdateAcademicRiskManagementUseCase(
          academicRiskManagementApiRepository,
        );
    }
    return _updateAcademicRiskManagementUseCase;
  };

export const endOfActionUseCase = (): EndOfActionUseCase => {
  if (!_endOfActionUseCase) {
    _endOfActionUseCase = new EndOfActionUseCase(
      academicRiskActionApiRepository,
    );
  }

  return _endOfActionUseCase;
};

export const filterFutureYearsAcademicRiskUseCase =
  (): FilterFutureYearsAcademicRiskUseCase => {
    if (!_filterFutureYearsAcademicRiskUseCase) {
      _filterFutureYearsAcademicRiskUseCase =
        new FilterFutureYearsAcademicRiskUseCase();
    }

    return _filterFutureYearsAcademicRiskUseCase;
  };

export const consolidateAllAcademicRiskDataUseCase =
  (): ConsolidateAllAcademicRiskDataUseCase => {
    if (!_consolidateAllAcademicRiskDataUseCase) {
      _consolidateAllAcademicRiskDataUseCase =
        new ConsolidateAllAcademicRiskDataUseCase();
    }

    return _consolidateAllAcademicRiskDataUseCase;
  };

export const resetAcademicRiskContainer = (): void => {
  _aggregateAcademicRiskCountersUseCase = null;
  _createAcademicRiskActionUseCase = null;
  _createAcademicRiskManagementUseCase = null;
  _deleteAcademicRiskActionUseCase = null;
  _deleteAcademicRiskManagementUseCase = null;
  _filterAcademicRiskDataUseCase = null;
  _filterAcademicRiskUIUseCase = null;
  _filterVigenteStudentsUseCase = null;
  _filterStudentsByCurrentYearAcademicRiskUseCase = null;
  _getAcademicRiskActionUseCase = null;
  _getAcademicRiskManagementUseCase = null;
  _getAcademicRiskStudentUseCase = null;
  _getActionTypesUseCase = null;
  _getRiskTypesUseCase = null;
  _processAcademicRiskStudentDataUseCase = null;
  _updateAcademicRiskActionUseCase = null;
  _updateAcademicRiskManagementUseCase = null;
  _filterAcademicRiskDataUseCase = null;
  _consolidateAllAcademicRiskDataUseCase = null;
  _endOfActionUseCase = null;
};
